define('modules/form_editor/views/editor_custom_range',['require','exports','module','base/view','../../editor/models/editorstate','ldsh!../templates/editor_custom_range'],function(require, exports, module){
  "use strict";
  var BaseView = require("base/view"),
      EditorState = require("../../editor/models/editorstate");
  module.exports = BaseView.extend({
    template: require("ldsh!../templates/editor_custom_range"),
    events: {
      "change .js-first": "updateModel",
      "change .js-start": "updateModel",
      "change .js-end": "updateModel",
      "change .js-fill-zeroes": "updateModel"
    },
    initialize: function(options){
      this.listenTo(this.model, "invalid", this.render);
    },
    helpers: function() {
      return {
        showZeroFillCheck: this.model.isZeroFillable,
        isAMP: EditorState.getAMPState()
      };
    },
    updateModel: function(e){
      var isFirstValid = this.$(".js-first").is(":checked"),
          start = +this.$(".js-start").val().trim(),
          end = +this.$(".js-end").val().trim(),
          fillWithZeroes = this.$(".js-fill-zeroes").is(":checked");
      this.model.set({
        start: start,
        end: end,
        firstOptionInvalid: isFirstValid,
        fillWithZeroes: fillWithZeroes
      }, { validate: true });
    },
    onRender: function(){
      this.$el.i18n();
    }
  });
});

